export default class VideoInView {
  constructor(element) {
    this.element = element;
    this.delay = 200;
  }

  init() {
    window.addEventListener('toggleVideo', (event) => {
      const { way } = event.detail;
      if (way !== 'enter') {
        if (!this.element.paused) {
          clearTimeout(this.timeout);
          this.element.pause();
        }
      } else {
        if (this.element.paused) {
          this.timeout = setTimeout(() => this.element.play(), this.delay);
        }
      }
    });
    return this;
  }
}
